export const EVENTS_SECTION = 'events'
export const LOCATIONS_SECTION = 'locations'

const EVENT_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function normalizeHashId(id) {
	if (!id) {
		return ''
	}

	if (id.startsWith('section-')) {
		return id.slice('section-'.length)
	}

	return id
}

export function isValidEventDate(value) {
	return EVENT_DATE_PATTERN.test(value)
}

/**
 * @param {string} [hash]
 * @returns {{ section: string, eventDate: string | null, locationId: string | null }}
 */
export function parsePageHash(hash = window.location.hash) {
	const raw = (hash || '').replace(/^#/, '')
	if (!raw) {
		return { section: '', eventDate: null, locationId: null }
	}

	const slash = raw.indexOf('/')
	if (slash === -1) {
		return { section: normalizeHashId(raw), eventDate: null, locationId: null }
	}

	const section = normalizeHashId(raw.slice(0, slash))
	const subpath = raw.slice(slash + 1).trim()

	if (section === EVENTS_SECTION) {
		return {
			section,
			eventDate: isValidEventDate(subpath) ? subpath : null,
			locationId: null,
		}
	}

	if (section === LOCATIONS_SECTION && subpath !== '') {
		return {
			section,
			eventDate: null,
			locationId: subpath,
		}
	}

	return { section, eventDate: null, locationId: null }
}

/**
 * @param {string | null | undefined} eventDate
 */
export function hashForEventsSlide(eventDate) {
	if (!eventDate || !isValidEventDate(eventDate)) {
		return `#${EVENTS_SECTION}`
	}

	return `#${EVENTS_SECTION}/${eventDate}`
}

/**
 * @param {string | null | undefined} locationId
 */
export function hashForLocationsSlide(locationId) {
	if (!locationId) {
		return `#${LOCATIONS_SECTION}`
	}

	return `#${LOCATIONS_SECTION}/${encodeURIComponent(locationId)}`
}

/**
 * @param {string} eventDate
 * @param {{ push?: boolean }} [options]
 */
export function setEventsPageUrl(eventDate, { push = false } = {}) {
	if (!isValidEventDate(eventDate)) {
		return
	}

	const base = `${window.location.pathname}${window.location.search}`
	const hash = hashForEventsSlide(eventDate)
	const nextUrl = `${base}${hash}`
	const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`

	if (currentUrl === nextUrl) {
		return
	}

	const state = { fullpage: hash, eventDate }

	if (push) {
		history.pushState(state, '', nextUrl)
	} else {
		history.replaceState(state, '', nextUrl)
	}
}

/**
 * @param {string} locationId
 * @param {{ push?: boolean }} [options]
 */
export function setLocationsPageUrl(locationId, { push = false } = {}) {
	if (!locationId) {
		return
	}

	const base = `${window.location.pathname}${window.location.search}`
	const hash = hashForLocationsSlide(locationId)
	const nextUrl = `${base}${hash}`
	const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`

	if (currentUrl === nextUrl) {
		return
	}

	const state = { fullpage: hash, locationId }

	if (push) {
		history.pushState(state, '', nextUrl)
	} else {
		history.replaceState(state, '', nextUrl)
	}
}

export function isEventsSlideActive() {
	const slide = document.querySelector('.fullpage-slide--events')
	return slide?.classList.contains('swiper-slide-active') ?? false
}

export function isLocationsSlideActive() {
	const slide = document.querySelector('.fullpage-slide--locations')
	return slide?.classList.contains('swiper-slide-active') ?? false
}
